import { postDataProcessor } from '@leagueplatform/masonry-api';
import { getFieldValue } from 'utils/data-processor.utils';
import { MESSAGE_FIELD_ID, SUCCESS_FIELD_ID } from 'types/data-processor.types';

const DELETE_USER_DATA_PROCESSOR_ID = 'deleteUser';
const DEFAULT_ERROR_MESSAGE =
  'Unable to delete user account. Please try again.';
const TYPE_FIELD_ID = 'type';
const ID_FIELD_ID = 'id';
const SYSTEM_ID_FIELD_ID = 'systemId';

export async function deleteMedibankUser(systemUuid: string): Promise<void> {
  const response = await postDataProcessor({
    dataProcessorId: DELETE_USER_DATA_PROCESSOR_ID,
    fields: [
      { id: TYPE_FIELD_ID, value: '' },
      { id: ID_FIELD_ID, value: '' },
      { id: SYSTEM_ID_FIELD_ID, value: systemUuid },
    ],
  });

  if (response.status !== 'success') {
    throw new Error(
      response.message ||
        response.errors?.[0]?.message ||
        DEFAULT_ERROR_MESSAGE,
    );
  }

  const success = getFieldValue(response.fields, SUCCESS_FIELD_ID) === true;

  if (!success) {
    const rawMessage = getFieldValue(response.fields, MESSAGE_FIELD_ID);
    const message =
      typeof rawMessage === 'string' && rawMessage
        ? rawMessage
        : DEFAULT_ERROR_MESSAGE;
    throw new Error(message);
  }
}
